import React from 'react';
import './Sponsors.css';

const Sponsors = () => {
  return (
    <div id='sponsor' className="sponsors-section">
      <h2>Sponsors</h2>
      <div className="sponsors-logo-grid" aria-label="Symposium sponsors">
        <div className="sponsor-logo-item">
          <img
            src={`${process.env.PUBLIC_URL}/sponsors/fortis-logo.svg`}
            alt="Fortis"
            className="sponsor-logo sponsor-logo-fortis"
          />
        </div>
        <div className="sponsor-logo-item">
          <img
            src={`${process.env.PUBLIC_URL}/sponsors/its-ny-logo.png`}
            alt="ITS New York"
            className="sponsor-logo sponsor-logo-its"
          />
        </div>
        <div className="sponsor-logo-item">
          <img
            src={`${process.env.PUBLIC_URL}/sponsors/transcore-logo.png`}
            alt="TransCore"
            className="sponsor-logo sponsor-logo-transcore"
          />
        </div>
        <div className="sponsor-logo-item">
          <img
            src={`${process.env.PUBLIC_URL}/sponsors/kld-logo.png`}
            alt="KLD"
            className="sponsor-logo sponsor-logo-kld"
          />
        </div>
      </div>
      <p className="sponsors-contact">
        Interested in being a sponsor of the symposium? Contact{' '}
        <a href="mailto:c2smart@nyu.edu">c2smart@nyu.edu</a> to learn about
        sponsorship opportunities.
      </p>
    </div>
  );
};

export default Sponsors;
